import * as types from '../constants/action-types';
import { omit } from '../helpers';
const errorInitialState = {};
export const errorReducer = (state = errorInitialState, action) => {
    switch (action.type) {
        case types.ADD_ERROR: {
            const { requestId, error } = action.payload;
            return { ...state, [requestId]: error };
        }
        case types.REMOVE_ERROR: {
            return omit(action.payload, state);
        }
        case types.RESET: {
            return errorInitialState;
        }
        default:
            return state;
    }
};
export default errorReducer;
